/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
// import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";

// Billing page components
import Transaction from "layouts/retailerTransactions/components/Transaction";

function Transactions({transactions}) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} pb={2} px={2}>
        <MDBox
          component="ul"
          display="flex"
          flexDirection="column"
          p={0}
          m={0}
          sx={{ listStyle: "none" }}
        >
          {transactions && 'data' in transactions && 'transactions' in transactions['data'] && transactions['data']['transactions'].map((transaction, index) => (
            <Transaction
              transaction={transaction}
              index={index}
            />
          ))}
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Transactions;
